import React from "react"
import { IconSignature } from "@tabler/icons-react"
import stoneImage from "images/love_irish/adventure/objects/ogham-stone.png"
import BaseListItem from "../base"
import { actionKeys } from "@love-irish/i18n"

export interface GuestbookListItemProps {
  item: Record<string, any>
  className?: string
  footer?: React.ReactNode
}

export const GuestbookListItem: React.FC<GuestbookListItemProps> = ({
  item,
  className,
  footer,
}) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconSignature}
    typeLabel="Guestbook"
    typeTooltip="Old Ogham stones which can be signed like a guestbook"
    testId="guestbook-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.SIGN }}
    media={
      <a href={item.path}>
        <img loading="lazy"
          src={item.imageUrl || item.thumbnailUrl || stoneImage}
          alt={item.name}
          className="max-w-[150px] rounded-lg"
        />
      </a>
    }
  />
)

export default GuestbookListItem
